import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CardWrapper, BoxLinkShare } from './styles';

// Modal de compartilhamento de link
const ShareModal = ({ onClose, handleCopyText }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef}>
      <IconButton
        color="secondary"
        onClick={() => onClose(false)}
      >
        <CloseIcon />
      </IconButton>
      <Title secondary>
        Compartilhe essa oportunidade com os seus amigos!
      </Title>
      <Text>Copie o link abaixo do nosso site! Assim poderá enviar como mensagem.</Text>
      <BoxLinkShare>
        <Text>{window.location.href}</Text>
        <CopyToClipboard
          text={window.location.href}
          onCopy={handleCopyText}
        >
          <Button>
            Copiar link
          </Button>
        </CopyToClipboard>
      </BoxLinkShare>
    </CardWrapper>
  );
};

ShareModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  handleCopyText: PropTypes.func.isRequired,
};

export default ShareModal;
